import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Hurricane01 = function Hurricane01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16.5 20.5002C15.2465 20.814 13.6884 21 12 21s-3.2465-.186-4.5-.4998M18 16.4305c-1.4659.5537-3.6106.9028-6 .9028s-4.5341-.3491-6-.9028m-1.5-4.7626c1.4314.8919 4.2531 1.4988 7.5 1.4988s6.0686-.6069 7.5-1.4988M21 6c0 1.6569-4.0294 3-9 3S3 7.6569 3 6s4.0294-3 9-3 9 1.3431 9 3"
    })
  }));
};
export default Hurricane01;